// extracted by mini-css-extract-plugin
module.exports = {"list":"SizesList_list__zhdgN","item":"SizesList_item__ZFYd1"};